<template>
  <div class="box">
    <!-- 修改密码 -->
    <div class="changePassword">
      <div class="title">
        <span>修改密码</span>
        <el-button @click="editPwd()" type="primary">保存</el-button>
      </div>
      <div class="bg_box">
        <div class="input_box">
          <span>原密码：</span>
          <el-input v-model="password" show-password></el-input>
        </div>
        <div class="input_box">
          <span>新密码：</span>
          <el-input v-model="newPassword" show-password></el-input>
        </div>
        <div class="input_box">
          <span>确认密码：</span>
          <el-input v-model="repeatpassword" show-password></el-input>
        </div>
      </div>
    </div>

    <div class="modificationOfMaterials">
      <div class="title">
        <span>修改资料</span>
      </div>

      <!-- 修改个人信息 -->
      <div class="bg_box">
        <div class="input_item">
          <div class="input_box_2">
            <span>用户名：</span>
            <el-input v-model="nickname"></el-input>
          </div>
          <div class="input_box_2">
            <span>手机号：</span>
            <el-input v-model="mobile"></el-input>
          </div>
        </div>
        <div class="input_item">
          <div class="input_box_2">
            <span>QQ号：</span>
            <el-input v-model="qq"></el-input>
          </div>
          <div class="input_box_2">
            <span>电子邮箱：</span>
            <el-input v-model="email"></el-input>
          </div>
        </div>
        <div class="line"></div>
        <el-button class="saveBtn" @click="upDateFn()" type="primary">保存</el-button>
      </div>
    </div>


  </div>
</template>

<script>
import Title from '../../components/UserInfoTitle.vue'

export default {
  components: {
    Title,
  },
  mounted() {

    if (localStorage.getItem('user_info')) {
      let user_info = JSON.parse(localStorage.getItem('user_info'))
      // console.log('mountedUser:', user_info);
      this.nickname = user_info.username
      this.mobile = user_info.mobile
      this.qq = user_info.qq
      this.email = user_info.email
    }
    // console.log('user_infoMouted:', this.$user_info);
  },
  data() {
    return {
      nickname: '',
      mobile: '',
      qq: '',
      email: '',
      password: '',
      newPassword: '',
      repeatpassword: '',
    }
  },
  methods: {
    upDateFn() {
      this.curlPost('/api/user/edit', {
        nickname: this.nickname,
        mobile: this.mobile,
        qq: this.qq,
        email: this.email,
      }).then(res => {
        if (res.data.code) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getUserInfo()


        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
        setTimeout(() => {
          this.$router.push({
            path: '/user/index',
          })
        }, 1000)
      })
    },
    // 获取用户信息
    getUserInfo() {
      this.curlGet('/api/user/info').then((res) => {
        if (res.data.code) {
          this.$user_info = res.data.data
          // console.log('user_info:', this.$user_info);
          this.$util.setLocalStorage('user_info', res.data.data) // 写入local storage

        }
      })
    },
    editPwd() {
      this.curlPost('/api/user/edit_pwd', {
        password: this.password,
        newpassword: this.newPassword,
        repeatpassword: this.newPassword,
      }).then(res => {
        if (res.data.code) {
          this.$message({message: '修改成功', type: 'success'})
          setTimeout(() => {
            this.$router.push({
              path: '/user/index',
            })
          }, 1000)
        } else {
          return this.$message({message: res.data.msg, type: 'error'})
        }

        // this.getUserInfo()
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@use '@/scss/Resource';
</style>